/**
 * エラーコード
 */
enum ErrorCode {
  /** 400エラーのコード */
  SFR0101 = 'SFR0101',
  /** 401エラーのコード */
  SFR0102 = 'SFR0102',
  /** 403エラーのコード */
  SFR0103 = 'SFR0103',
  /** 404エラーのコード */
  SFR0104 = 'SFR0104',
  /** 409エラーのコード */
  SFR0105 = 'SFR0105',
  /** 415エラーのコード */
  SFR0106 = 'SFR0106',
  /** 500エラーのコード */
  SFR0107 = 'SFR0107',
  /** 502エラーのコード */
  SFR0108 = 'SFR0108',
  /** 503エラーのコード */
  SFR0109 = 'SFR0109',
  /** 504エラーのコード */
  SFR0110 = 'SFR0110',
  /** その他HTTPエラーのコード */
  SFR0111 = 'SFR0111',
  /** ネットワークエラーのコード */
  SFR0112 = 'SFR0112',
  /** その他ロジックエラーのコード */
  SFR0201 = 'SFR0201'
}

namespace ErrorCode {
  /**
   * 固定部メッセージを取得する
   * @param code コード
   * @returns 固定部メッセージ
   */
  export const getMsg = (code: string) => {
    return errorMsgMap.get(code) || '';
  };
  /**
   * 画面表示メッセージのキーを取得する
   * @param code コード
   * @returns 画面表示メッセージのキー
   */
  export const getDispMsgKey = (code: string) => {
    return errorKeyMap.get(code) || '';
  };
}

const errorMsgMap = new Map<string, string>();
errorMsgMap.set(ErrorCode.SFR0101, 'Bad Request');
errorMsgMap.set(ErrorCode.SFR0102, 'Unauthorized');
errorMsgMap.set(ErrorCode.SFR0103, 'Forbidden');
errorMsgMap.set(ErrorCode.SFR0104, 'Not Found');
errorMsgMap.set(ErrorCode.SFR0105, 'Conflict');
errorMsgMap.set(ErrorCode.SFR0106, 'Unsupported Media Type');
errorMsgMap.set(ErrorCode.SFR0107, 'Internal Server Error');
errorMsgMap.set(ErrorCode.SFR0108, 'Bad Gateway');
errorMsgMap.set(ErrorCode.SFR0109, 'Service Unavailable');
errorMsgMap.set(ErrorCode.SFR0110, 'Gateway Timeout');
errorMsgMap.set(ErrorCode.SFR0111, 'Unexpected Http Request Error');
errorMsgMap.set(ErrorCode.SFR0112, 'Network Error');
errorMsgMap.set(ErrorCode.SFR0201, 'Front-end logic error');

const errorKeyMap = new Map<string, string>();
errorKeyMap.set(ErrorCode.SFR0101, 'errHandler.message.disp.http400');
errorKeyMap.set(ErrorCode.SFR0102, 'errHandler.message.disp.http401');
errorKeyMap.set(ErrorCode.SFR0103, 'errHandler.message.disp.http403');
errorKeyMap.set(ErrorCode.SFR0104, 'errHandler.message.disp.http404');
errorKeyMap.set(ErrorCode.SFR0105, 'errHandler.message.disp.http409');
errorKeyMap.set(ErrorCode.SFR0106, 'errHandler.message.disp.http415');
errorKeyMap.set(ErrorCode.SFR0107, 'errHandler.message.disp.http500');
errorKeyMap.set(ErrorCode.SFR0108, 'errHandler.message.disp.http502');
errorKeyMap.set(ErrorCode.SFR0109, 'errHandler.message.disp.http503');
errorKeyMap.set(ErrorCode.SFR0110, 'errHandler.message.disp.http504');
errorKeyMap.set(ErrorCode.SFR0111, 'errHandler.message.disp.httpOther');
errorKeyMap.set(ErrorCode.SFR0112, 'errHandler.message.disp.network');

export { ErrorCode };
